import { makeAutoObservable } from "mobx";
import {
  getPatientBySearchDto,
  saveOrUpdateList,
  getPatientById
} from "./PatientMedicationHistoryService";
import { getEtbByPatientId } from "../Patient/Services/EtbTreatmentBookService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import i18n from "i18n";

export default class PatientMedicationHistoryStore {
  loadingInitial = false;
  selectedPatientMedicationHistory = [];
  selectedId = null;
  selectedPatient = null;
  listTreatmentPeriod = [];
  selectedPeriod = null;
  
  resetStore = () => {
    this.selectedPatientMedicationHistory = [];
    this.selectedId = null;
    this.selectedPatient = null;
    this.listTreatmentPeriod = [];
    this.selectedPeriod = null;
  }

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  getPatientMedicationHistory = async () => {
    this.loadingInitial = true;
    try {
      let res = await getPatientBySearchDto({
        patientId: this.selectedId,
        periodId: this.selectedPeriod?.id,
      });
      this.handleSelectPatientMedicationHistory(res.data);
      return this.selectedPatientMedicationHistory;
    } catch (error) {
      console.log(error);
      toast.warning("toast.get_fail");
    }
    this.setLoadingInitial(false);
  };

  getDetailPatient = (id) => {
    getPatientById(id).then(({data}) => {
      this.handleSelectPatient(data)
    }).catch(error => {
      console.error(error);
      toast.warning("toast.get_fail");
    })
  }

  getListTreatmentPeriodEtbByPatientId = id => {
    getEtbByPatientId(id).then(({data}) => {
      if (data?.length > 0) {
        this.handleSelectPatientId(id);
        this.handleChangePeriod(data?.[0])
        this.handleSelectListTreatmentPeriod(data)
      } else {
        this.handleSelectListTreatmentPeriod([])
      }
    }).catch(error => {
      console.error(error);
      toast.warning("toast.get_fail");
    })
  }

  handleSelectListTreatmentPeriod = list => {
    this.listTreatmentPeriod = [...list]
  }

  handleSelectPatient = (obj) => {
    this.selectedPatient = {...obj}
  }

  handleSelectPatientId = id => {
    this.selectedId = id
  }

  handleSelectPatientMedicationHistory = data => {
    this.selectedPatientMedicationHistory = data
  }

  saveOrUpdateList = (values, formhelper) => {
    saveOrUpdateList(
      values?.patientMedicationHistorys,
      this.selectedPeriod?.id
    ).then(() => {

      toast.success("Đã cập nhật thông tin")
      //lưu xong get lại
      this.getPatientMedicationHistory()
      formhelper.setSubmitting(false);
    }).catch((e) => {
      console.error(e);
      toast.warning(i18n.t("toast.error"));
      formhelper.setSubmitting(false);
    })
  }

  handleChangePeriod = (period) => {
    this.selectedPeriod = period;
    getPatientBySearchDto({
      patientId: this.selectedId,
      periodId: period?.id,
    }).then(({data}) => {
      if (data?.length > 0) {
        this.handleSelectPatientMedicationHistory(data);
      } else {
        this.handleSelectPatientMedicationHistory([])
      }
    }).catch(error => {
      console.error(error);
      toast.warning("toast.get_fail");
    })
  }

}
